<div class="ir-area ir-header th-header">
  <div class="ir-line th-header-line" *ngIf="!showSearch">
    <div class="ir-line--left">
      <div class="ir-btn th-btn-normal" (click)="goToBack()">
        <i class="material-icons">arrow_back</i>
      </div>
    </div>
    <div class="ir-line--right">
      <div class="ir-btn th-btn-normal" (click)="updateShowSearch()">
        <i class="material-icons">search</i>
      </div>
      <div class="ir-btn th-btn-normal" (click)="openMenu()">
        <i class="material-icons">more_vert</i>
      </div>
    </div>
    <div class="ir-line-content">
      <span>{{ i18nPrefix + '.detail.title' | translate }}</span>
    </div>
  </div>
  <div class="ir-line th-header-search" *ngIf="showSearch">
    <div class="ir-line--left">
      <div class="ir-btn th-btn-unactive">
        <i class="material-icons">search</i>
      </div>
    </div>
    <div class="ir-line--right">
      <div class="ir-btn th-btn-search" (click)="updateShowSearch(false)">
        <i class="material-icons">close</i>
      </div>
    </div>
    <div class="ir-line-content">
      <input
        autoFocus
        type="search"
        name="Search"
        placeholder="{{ 'common.placeholders.search' | translate }}"
        [(ngModel)]="query"
        focus="showSearch"
      />
    </div>
  </div>
</div>
<div class="ir-area ir-body th-body">
  <div class="th-loading" *ngIf="loading">
    <span>{{ 'common.loading' | translate }}...</span>
  </div>
  <action-plan-detail
    [actionPlan]="actionPlan"
    (toggleSelectResponsible)="openResponsible($event)"
    [query]="query"
  ></action-plan-detail>
</div>

<modal (modalOutput)="selectMenu($event)"></modal>
<confirm
  #doneConfirm
  (confirmOutput)="markAsDone($event)"
  [title]="'actionPlan.done' | translate"
  [message]="'actionplans.sure-to-done' | translate"
></confirm>
<modal (modalOutput)="createReport($event)" #reportLangModal></modal>
<inputlang
  #languagesModal
  (modalOutput)="selectLanguagesMenu($event)"
  [title]="'inspections.change-input-lang' | translate"
  [message]="'inspections.change-input-lang-warning' | translate"
  [danger]="true"
></inputlang>
